import { Status } from './../status';
import api from '../api';
import Axios from 'axios';
import { getJwt } from '@app/helpers';

export interface Autorizacao {
  id: string;
  documentoCobrancaNumero?: string;
  medicaoId: string;
  tipoDocumentoCobrancaId?: string;
  estabelecimentoId?: string;
  valor?: number;
  dataAutorizacao?: Date;
  matchingERP?: string;
  status?: string;
  statusCodigo?: number;
  numeroAutorizacao?: string;

  nomeArquivo?: string;
  localArquivo?: string;

  tipoDocumentoCobranca?: string;
  estabelecimento?: string;
  valorString: string;

  planilhaRateioId: string;

  arquivosAutorizacao: ArquivosAutorizacao[];
  arquivosComprovanteCancelamento: ArquivoComprovanteCancelamento[];
  arquivosCartaCorrecao: ArquivoCartaCorrecao[];
  parcelasPagamento: ParcelasPagamento[];
}

export interface ParcelasPagamento {
  documentoCobrancaId: string;
  parcelaCobrancaNumero: string;
  dataPrevisaoPagamento: string;
  valor: string;
}

export interface ArquivoComprovanteCancelamento {
  id: string;
  dataInclusao: Date;
  nome: string;
  responsavel: string;
}

export interface ArquivoCartaCorrecao {
  id: string;
  dataInclusao: Date;
  nome: string;
  responsavel: string;
}

export interface ArquivosAutorizacao {
  dataEmissao: Date;
  numero: string;
  valor: number;
  nome: string;
  responsavel: string;
  dataInclusao: Date;
  statusArquivoAutorizacao: Status;
}

export interface SituacaoProcessoInfo {
  status: string;
  statusCodigo?: number;
  valorMedicao?: number;
  valorAutorizado?: number;
  valorMedicaoMenosValorPenalti?: number;
  valorPenalti?: number;
  valorPago?: number;
  autorizacoesId: string[];
  dataHoraUltimaTrocaStatusAutorizacaoPagamento?: Date;
}

export interface AutorizacaoMatchingInfo {
  id: string;
  fornecedor: string;
  contrato: string;
  documentoCobrancaNumero: string;
  tipoDocumentoCobranca: string;
  documentoCobrancaId?: string;
  statusCodigo?: number;
  valor: string;
  localArquivo: string;
  nomeArquivo: string;
}

export const getAutorizacaoMatchingInfo = (data: any) =>
  api.post<AutorizacaoMatchingInfo[]>('matching', data, { disableNotification: true });

export const getAllAutorizacoes = () => api.get<Autorizacao[]>('autorizacoes');

export const getAutorizacaoById = (autorizacaoId: string) => api.get<Autorizacao>(`autorizacoes/${autorizacaoId}`);

export const getSituacaoProcessoInfo = (medicaoId: any) =>
  api.get<SituacaoProcessoInfo>(`autorizacoes/situacaoProcesso/${medicaoId}`);

export const createAutorizacao = (medicaoId: string, Autorizacao: any) => {
  return api.post<any>(`autorizacoes/medicao/${medicaoId}`, Autorizacao);
};

export const createAutorizacaoNovo = (Autorizacao: any) => {
  return api.post<any>(`autorizacoes/creatMedicao`, Autorizacao);
};

export const updateAutorizacao = (Autorizacao: Autorizacao) =>
  api.put<any>(`autorizacoes/${Autorizacao.id}`, Autorizacao);

export const handleMatchingAutorizacao = (autorizacaoId: string, optionValue: string) => {
  let data = {
    autorizacaoId: autorizacaoId,
    optionValue: optionValue,
  };
  return api.put<any>(`autorizacoes/matching`, data);
};

export const updateDadosCobranca = (file: any, Autorizacao: Autorizacao, autorizacaoId: string) => {
  const form = new FormData();
  Object.keys(Autorizacao).forEach(key => {
    form.append(key, Autorizacao[key]);
  });
  form.append('file', file);
  form.append('AutorizacaoId', autorizacaoId);
  form.append('valorTexto', Autorizacao['valor']);

  return api.put(`autorizacoes/dadosCobranca`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateDataAutorizacao = (autorizacao: Autorizacao) => {
  return api.put(`autorizacoes/updateData`, { id: autorizacao['id'], data: autorizacao['dataAutorizacao'] });
};

export const deleteAutorizacao = (autorizacaoId: string) => {
  return api.delete<any>(`autorizacoes/${autorizacaoId}`);
};

export const sendToFornecedor = (medicaoId: string, autorizacaoId: string) => {
  const form = new FormData();
  form.append('autorizacaoId', autorizacaoId);
  return api.put<any>(`autorizacoes/enviar/medicao/${medicaoId}`, form);
};

export const viewArquivoAutorizacao = (id: string) => {
  var url = window.location.origin + `/api/autorizacoes/download/${id}`;
  Axios.get(url, {
    responseType: 'blob',
  }).then(response => {
    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    var resp = window.open(fileURL);
  });
};

export const downloadArquivoAutorizacao = (id: string, filename: string) => {
  var url = window.location.origin + `/api/autorizacoes/download/${id}`;
  Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElement').outerHTML = '';
  });
};

export const viewArquivoComprovanteCancelamento = (id: string) => {
  var url = window.location.origin + `/api/autorizacoes/downloadComprovanteCancelamento/${id}`;
  Axios.get(url, {
    responseType: 'blob',
  }).then(response => {
    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    var resp = window.open(fileURL);
  });
};

export const downloadArquivoComprovanteCancelamento = (id: string, filename: string) => {
  var url = window.location.origin + `/api/autorizacoes/downloadComprovanteCancelamento/${id}`;
  Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElement').outerHTML = '';
  });
};

export const viewArquivoCartaCorrecao = (id: string) => {
  var url = window.location.origin + `/api/autorizacoes/downloadCartaCorrecao/${id}`;
  Axios.get(url, {
    responseType: 'blob',
  }).then(response => {
    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    var resp = window.open(fileURL);
  });
};

export const downloadArquivoCartaCorrecao = (id: string, filename: string) => {
  var url = window.location.origin + `/api/autorizacoes/downloadCartaCorrecao/${id}`;
  Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElement').outerHTML = '';
  });
};

export const urlDownloadArquivo = '/api/autorizacoes/contrato/download?path=';
export const download = (path: string, fileName: string) => {
  Axios.get(`/api/autorizacoes/contrato/download?path=${path}&fileName=${fileName}`, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElement').outerHTML = '';
  });
};

// API -- Arquivos Autorizacao

export const solicitarCancelamentoSubstituicao = (arquivoAutorizacaoId: string, justificativa: string) => {
  return api.post<any>('arquivoAutorizacao/solicitarCancelamentoSubstituicao', { arquivoAutorizacaoId, justificativa });
};

export const anexarNovoDocumentoCobranca = (autorizacao: Autorizacao, arquivoAutorizacaoId: string) => {
  const form = new FormData();
  Object.keys(autorizacao).forEach(key => {
    form.append(key, autorizacao[key]);
  });
  form.append('fileDocumento', autorizacao['fileDocumento']);
  form.append('fileEvidencia', autorizacao['fileEvidencia']);
  form.append('arquivoAutorizacaoId', arquivoAutorizacaoId);
  form.append('valorTexto', autorizacao['valor']);
  return api.put(`arquivoAutorizacao/anexarNovoDocumento`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const anexarCartaCorrecao = (autorizacao: Autorizacao, arquivoAutorizacaoId: string) => {
  const form = new FormData();
  Object.keys(autorizacao).forEach(key => {
    form.append(key, autorizacao[key]);
  });
  form.append('fileCartaCorrecao', autorizacao['fileCartaCorrecao']);
  form.append('arquivoAutorizacaoId', arquivoAutorizacaoId);
  return api.put(`arquivoAutorizacao/anexarCartaCorrecao`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const substituirArquivoAutorizacao = (autorizacao: Autorizacao, arquivoAutorizacaoId: string) => {
  const form = new FormData();
  form.append('documentoCobrancaNumero', autorizacao['documentoCobrancaNumero']);
  form.append('dataEmissao', autorizacao['dataEmissao']);
  form.append('valor', autorizacao['valor']);
  form.append('valorTexto', autorizacao['valor']);
  form.append('fileDocumento', autorizacao['fileDocumento']);
  form.append('arquivoAutorizacaoId', arquivoAutorizacaoId);
  return api.put(`arquivoAutorizacao/substituirArquivoAutorizacao`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const solicitarSubstituicao = (arquivoAutorizacaoId: string, justificativa: string) => {
  return api.post<any>('arquivoAutorizacao/solicitarSubstituicao', { arquivoAutorizacaoId, justificativa });
};

export const acatarSubstituicao = (arquivoAutorizacaoId: string, justificativa: string) => {
  return api.post<any>('arquivoAutorizacao/acatarSubstituicao', { arquivoAutorizacaoId, justificativa });
};

export const reenviar = (arquivoAutorizacaoId: string, justificativa: string) => {
  return api.post<any>('arquivoAutorizacao/reenviar', { arquivoAutorizacaoId, justificativa });
};

export const rejeitarSubstituicao = (arquivoAutorizacaoId: string, justificativa: string) => {
  return api.post<any>('arquivoAutorizacao/rejeitarSubstituicao', { arquivoAutorizacaoId, justificativa });
};

export const solicitarCorrecao = (arquivoAutorizacaoId: string, justificativa: string) => {
  return api.post<any>('arquivoAutorizacao/solicitarCorrecao', { arquivoAutorizacaoId, justificativa });
};

export const getJustificativas = (arquivoAutorizacaoId: string) => {
  return api.get<any>(`arquivoAutorizacao/getJustificativas/${arquivoAutorizacaoId}`);
};

export const salvarJustificativa = (form: any) => {
  return api.put('arquivoAutorizacao/salvarJustificativa', form);
};
